export const sorts = {
  default: [],
  options: [
    {
      name: 'Links',
      key: 'links',
      options: [{ key: '-links', value: 'Most' }, { key: 'links', value: 'Least' }]
    },
    {
      name: 'Clicks',
      key: 'clicks',
      options: [{ key: '-clicks', value: 'Most' }, { key: 'clicks', value: 'Least' }]
    },
    {
      name: 'Sales',
      key: 'gmv',
      options: [{ key: '-gmv', value: 'Most' }, { key: 'gmv', value: 'Least' }]
    },
    {
      name: 'Cost',
      key: 'cost',
      options: [{ key: '-cost', value: 'Most' }, { key: 'cost', value: 'Least' }]
    },
    {
      name: 'Roas',
      key: 'roas',
      options: [{ key: '-roas', value: 'Most' }, { key: 'roas', value: 'Least' }]
    }
  ]
};